import { Button, ModalBody, ModalContent, ModalFooter, ModalHeader, Textarea } from "@heroui/react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useTranslation } from "react-i18next";
import { useAppApi } from "src/appApi";
import { TRequest } from "@shared/entities";

const formSchema = z.object({
	adminMessageForBroker: z.string().nonempty({ message: "שדה חובה" }).optional(),
});

type Form = z.infer<typeof formSchema>;

export function AdminReturnRequestToBrokerModal({
	request,
	onSubmit,
}: {
	request: TRequest;
	onSubmit?: (request: Partial<TRequest>) => void;
}) {
	const { t } = useTranslation(["common", "admin"]);

	const appApi = useAppApi();

	const form = useForm<Form>({
		resolver: zodResolver(formSchema),
	});

	const _onSubmit = async (data: Form) => {
		if (!request.id) return;

		const res = await appApi.api.admin.requestChangesFromBroker({
			id: request.id,
			adminMessageForBroker: data.adminMessageForBroker,
		});

		if (res?.success) {
			onSubmit?.(res.data);
		} else {
			form.setError("root", { message: "global error" });
		}
	};

	return (
		<ModalContent onSubmit={form.handleSubmit(_onSubmit, console.warn)} as={"form"}>
			{(onClose) => {
				return (
					<>
						<ModalHeader>החזר בקשה למתווך</ModalHeader>
						<ModalBody className="">
							<Textarea
								label={t("common:message")}
								placeholder="הסבר מה נדרש מהמתווך לעדכן"
								{...form.register("adminMessageForBroker", {})}
								errorMessage={form.formState.errors.adminMessageForBroker?.message}
								isInvalid={!!form.formState.errors.adminMessageForBroker?.message}
							/>
						</ModalBody>
						<ModalFooter className="">
							<Button variant="light" onPress={onClose}>
								ביטול
							</Button>
							<Button
								isLoading={appApi.loading["admin.requestChangesFromBroker"]}
								type="submit"
								color="primary"
							>
								אישור
							</Button>
						</ModalFooter>
					</>
				);
			}}
		</ModalContent>
	);
}

